<template>
    <transition name="fade-out">
        <section>
            <div class="bg-gray-300/50">
                <div
                    class="w-full flex px-4 md:px-22 lg:px-24 xl:px-32 bg-[url('/src/assets/groups/img3.jpg')] bg-center bg-cover bg-blend-multiply bg-[#5e5d5d] h-fit md:h-[100vh] top-0"
                >
                    <div
                        data-aos="fade-up"
                        data-aos-easing="lienar"
                        data-aos-duration="1000"
                        class="flex flex-col self-center items-start rounded-md w-full 2xl:w-2/3 h-fit px-0 py-6 xl:p-16 mt-32 md:mt-16"
                    >
                        <p
                            class="text-xl xl:text-3xl text-left text-[#EBAC0D] leading-[3rem]"
                        >
                            Trudna si?
                        </p>
                        <p
                            class="leading-[2rem] md:leading-10 2xl:leading-10 pb-6 pt-3 xl:pt-4 xl:pb-0 text-sm md:text-md 2xl:text-lg text-white text-left"
                        >
                            Možda prvi put — sve ti je novo, nepoznato i pomalo
                            zastrašujuće. <br />
                            A možda već jesi rodila, znaš što te čeka… ali ovaj
                            put želiš drugačije. <br />
                            Želiš porod po svojim pravilima. <br />
                            Da te se čuje, razumije i poštuje. <br />
                            Želiš miran postpartum, bez stresa i osjećaja da si
                            sama u svemu tome.
                        </p>
                    </div>
                    <img
                        src="/src/assets/arrow-down.svg"
                        class="absolute hidden md:flex items-center text-white bottom-8 left-[50%] animate-bounce cursor-pointer"
                        @click="goDown"
                    />
                </div>
            </div>

            <div
                class="relative flex flex-col 3xl:flex-row items-center sm:items-end xl:items-start 3xl:items-center justify-center py-0 xl:py-16 3xl:py-24 px-0 sm:px-0 md:px-22 lg:px-24 xl:px-32 bg-green-900/50 w-full gap-y-0 sm:gap-y-12 xl:gap-y-0"
                id="second-section"
            >
                <p
                    data-aos="fade-up"
                    data-aos-easing="lienar"
                    data-aos-duration="1000"
                    class="relative sm:absolute 3xl:relative z-0 sm:z-20 3xl:z-0 bottom-auto sm:bottom-4 md:bottom-auto left-auto sm:left-4 lg:left-24 xl:left-[35%] w-full sm:w-[90%] lg:w-[60%] xl:w-1/2 leading-[2rem] md:leading-10 2xl:leading-10 px-4 py-8 sm:py-8 md:py-16 text-sm md:text-md 2xl:text-lg text-white text-left bg-transparent sm:bg-neutral-700/80 3xl:bg-transparent rounded-md"
                >
                    Upravo zato sam pokrenula sam grupu za trudnice: “Podržane u
                    majčinstvu”. <br />
                    Malu i intimnu — da svaka trudnica ima prostor za sebe, ali
                    i osjećaj zajedništva. <br />
                    Da dobije znanje, alate i podršku koji će joj pomoći na
                    porodu i u prvim tjednima nakon njega. <br /><br />

                    Sve ono što ja nisam znala s prvom bebom, pa sam morala sama
                    tražiti odgovore — sada dijelim s tobom.
                </p>
                <img
                    src="/src/assets/groups/img1.jpg"
                    data-aos="fade-up"
                    data-aos-easing="lienar"
                    data-aos-duration="1000"
                    class="h-auto sm:h-auto w-full sm:w-[60%] md:w-1/2 lg-w-[50%] xl:w-[40%] p-0 xl:pt-8 rounded-md order-first md:order-last"
                />
            </div>

            <div
                class="relative flex flex-col lg:flex-row justify-start xl:justify-center items-center sm:items-start xl:items-center py-0 xl:py-24 2xl:py-36 px-0 sm:px-0 md:px-24 xl:pr-80"
            >
                <img
                    src="/src/assets/groups/img2.jpg"
                    class="relative xl:absolute w-full sm:w-[450px] md:w-[600px] h-auto right-none md:right-24 xl:right-20 2xl:right-48 3xl:right-80 z-0 md:z-[-1] rounded-none xl:rounded-md"
                    data-aos="fade-up"
                    data-aos-easing="lienar"
                    data-aos-duration="1500"
                />
                <div
                    class="relative md:absolute xl:relative right-auto md:right-4 xl:right-auto bottom-auto sm:bottom-4 md:bottom-10 lg:bottom-16 xl:bottom-auto w-full md:w-[80%] lg:w-[60%] xl:w-full flex flex-col bg-[#FFFAF0]/70 xl:bg-[#FFFAF0] h-fit 2xl:h-fit rounded-none md:rounded-md mr-0 xl:mr-[200px] 2xl:mr-[450px]"
                    data-aos="fade-up"
                    data-aos-easing="lienar"
                    data-aos-duration="1000"
                >
                    <p
                        class="text-left text-xl xl:text-xl text-[#fabb1e] font-['Merriweather'] px-4 pt-6 xl:px-12"
                    >
                        Grupa traje 2 mjeseca i imamo zajedničku WhatsApp grupu.
                    </p>
                    <p
                        class="leading-[2rem] md:leading-10 2xl:leading-10 text-black text-sm md:text-md text-start px-4 py-6 xl:px-12 xl:pb-12 h-auto rounded-md"
                    >
                        Dobit ćeš i pristup mojim snimljenim video lekcijama, a
                        teme su sljedeće: bebina priča, zlatni sat, presjecanje
                        pupkovine, kada u rodilište, vaginalni pregledi – što mi
                        znači koliko sam otvorena, pucanje i prokidanje
                        vodenjaka, epiduralna, drip, kaskada intervencija,
                        brijanje i klistir, epiziotiomija, CTG, dan termina, i
                        famozni 41 plus 3, faze poroda, prava na porodu,
                        oksitocin, plan poroda, uloga pratnje, komunikacija s
                        osobljem, odgoj, kako s više djece, prinova, što ako
                        stanu trudovi u rodilištu, kako olakšat trudove,
                        dojenje, svakodnevni pokreti u trudnoći, povezivanje s
                        bebom, vbac, zadak, carski rez, velika beba, skin to
                        skin, amnioskopija.
                        <br />
                        A kako bi iskustvo bilo još bogatije i stručnije, u
                        grupu sam uključila i stručnjakinje iz područja poroda i
                        postpartuma: postpartum doula i savjetnica za dojenje
                        Sonja Buzov, savjetnica za dojenje Katarina Škara,
                        fitness trenerica Diana Hajdo, postpartum doula Mihaela
                        Miholić, logoped i komunikacijski stručnjak Matea Jukić,
                        prof. i grupni voditelj instituta za psihoanalizu Lidija
                        Košir, doula Elizabeta Biličić, dr. Marija Križanović.
                        Svaka od njih održava za grupu jedan stručni zoom.
                    </p>
                </div>
            </div>

            <div
                class="flex flex-col justify-center items-center py-8 md:py-24 px-4 sm:px-12 md:px-24 xl:px-80 gap-12 bg-opacity-image bg-cover w-full gap-y-4 lg:gap-y-12 xl:gap-y-0"
            >
                <p
                    class="pb-3 md:pb-6 text-white text-center text-sm md:text-md 2xl:text-lg leading-[2rem] lg:leading-[3rem] 2xl:leading-10"
                    data-aos="fade-up"
                    data-aos-easing="lienar"
                    data-aos-duration="1000"
                >
                    Ako tražiš mjesto koje ti donosi mir, sigurnost, znanje i
                    vjeru u svoje tijelo, i želiš biti podržana u svojem
                    majčinstvu <br />
                    ✨ javi mi se i rezerviraj svoje mjesto! ✨
                </p>
                <p
                    class="text-xl md:text-2xl cursive text-[#fabb1e] text-left md:text-center"
                    data-aos="fade-up"
                    data-aos-easing="lienar"
                    data-aos-duration="1000"
                >
                    Dobrodošla si. ❤️
                </p>
            </div>
        </section>
    </transition>
</template>

<script>
export default {
    name: 'aboutMe',
    methods: {
        goDown() {
            const section = document.getElementById('second-section')
            section.scrollIntoView({ behavior: 'smooth' })
        },
    },
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Merriweather:ital,wght@0,300;1,300&display=swap');

section {
    font-family: 'Merriweather', serif;
}
.fade-out-enter-active,
.fade-out-leave-active {
    transition: opacity 0.5s;
}

.fade-out-enter,
.fade-out-leave-to {
    opacity: 0;
}
</style>
